module.exports = System.import('@enersis/gp-components/gp-map2-control');